<script type="text/ecmascript-6">
    import Layout from '../layouts/MainLayout.vue'
    import DateRange from "../components/DateRange";
    import TopHeader from "../components/TopHeader";
    import {mapGetters} from "vuex";

    export default {
        components: {TopHeader, DateRange, Layout },

        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isLoading: 'getIsLoading',
                isShow: 'getIsShow',
                isPreview: 'getIsPreview',
                isPrint: 'getIsPrint',
                pages: 'getPages',
            })
        },
    }
</script>

<template>
    <layout>
        <div :class="{'container-fluid' : !isPreview }" v-show="!isLoading">

            <date-range></date-range>

            <div class="card" :class="[{'mb-3': !isPreview}, {'border-0': isPreview}]" v-show="isShow">
                <div class="card-body">

                    <TopHeader name="Home"></TopHeader>

                    <div class="row mt-3">
                        <div class="col-md-4 mt-3" v-for="page in pages" v-bind:key="page.id">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex flex-row rounded">
                                        <div class="p-0">
                                            <img :src="page.picture" width="50" alt="" class="rounded-circle">
                                        </div>
                                        <div class="pl-3 pt-2 pr-2 pb-2 w-75">
                                            <h5 class="text-black"><a target="_blank" :href="'https://www.facebook.com/' + page.username">{{ page.name }}</a></h5>
                                            <h6 class="text-black">@{{ page.username }}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </layout>
</template>
